@if (showCheckoutCompletedOverlay()) {
  @defer {
    <app-payment-completed-overlay
      [checkoutMetadata]="checkoutMetadata()"
      (hide)="showCheckoutCompletedOverlay.set(false)"
    />
  }
}
